import cx from 'classnames';
import _ from 'lodash';
import React from 'react';
import { cloneChildren } from '../../_utils';
import { Divider } from '../../divider';
import { Typography } from '../../typography';
import { Menu } from '../menu';
import styles from '../menu.module.scss';
import { MenuVariant } from '../types';
export const MenuGroup = ({ children, showSeparator = true, headerText, variant = MenuVariant.DEFAULT, onMenuItemKeyPressCB = _.noop, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: cx(styles.menuGroupWrapper, {
                [styles.withHeaderText]: !!headerText,
            }) },
            headerText && (React.createElement("div", { className: styles.groupHeader },
                React.createElement(Typography, { variant: "p-bold" }, headerText))),
            React.Children.toArray(children).map((menuItem) => {
                let menuItemProps = {};
                /* Since in select-menu, Typography is also passed as a children to Menu.Group,
                    we need to only send variant prop in case of Menu.Item */
                if (menuItem.type === Menu.Item) {
                    menuItemProps = {
                        variant,
                        keyPressed: onMenuItemKeyPressCB,
                    };
                }
                return cloneChildren(menuItem, menuItemProps);
            })),
        children && showSeparator && React.createElement(Divider, null)));
};
//# sourceMappingURL=menu-group.js.map